import CheckCircle from '../../icons/check_circle.svg';
import Wrong from '../../icons/wrong.svg';

import { colorVariants } from '../../utils/constants/colors';

import { VisualQCStatus } from '../../utils/enums';

interface VisualQCStatusProps {
    status: VisualQCStatus;
}

export const VisualQC = ({ status }: VisualQCStatusProps) => {
    return (
        <div className={`flex text-white py-1 px-1 inline-flex rounded-full`} style={{ backgroundColor: status === VisualQCStatus.PASSED ? '#72B76C' : '#D23C33' }}>
            <img src={status === VisualQCStatus.PASSED ? CheckCircle : Wrong} alt="" className="mr-1" />
            <span style={{ fontSize: 12, fontWeight: 400, marginRight: 8 }}>{status === VisualQCStatus.PASSED ? 'Approved' : 'Not Approved'}</span>
        </div>
    );
};
